import React, {useContext} from 'react';
import {useIntl} from 'react-intl';

import 'shared/styles/table.style.less';
import {Button} from 'antd';
import AppPageMetadata from '@crema/core/AppPageMetadata';
import AppsContainer from '@crema/core/AppsContainer';
import AppsHeader from '@crema/core/AppsContainer/AppsHeader';
import AppsContent from '@crema/core/AppsContainer/AppsContent';
import PractitionerTable from './PractitionerTable';
import {PractitionerContext} from './PractitionerContext';
import {IoReload} from 'react-icons/all';

const PractitionerList = () => {
  const intl = useIntl();
  const practitionerContext = useContext(PractitionerContext);

  const {setReloading} = practitionerContext;

  return (
    <>
      <AppPageMetadata title={intl.messages['practitioner.list']} />
      <AppsContainer
        title={intl.messages['practitioner.list']}
        fullView
        type='bottom'>
        <AppsHeader key={'header'}>
          <div className='customer-header'>
            <div className='customer-header-input-view' />
            <div className='customer-header-right'>
              <Button
                type='primary'
                shape='circle'
                ghost
                icon={<IoReload />}
                onClick={() => setReloading(true)}
              />
            </div>
          </div>
        </AppsHeader>

        <AppsContent
          key={'content'}
          style={{
            paddingTop: 10,
            paddingBottom: 10,
          }}>
          <PractitionerTable />
        </AppsContent>
      </AppsContainer>
    </>
  );
};

export default PractitionerList;
